import { Component, Input, OnInit } from '@angular/core';
import { UploadFilesService } from './_services/upload-files.service';
import { AppAnalysisService } from './_services/app-analysis.service';
// import { UploadFilesService } from './services/upload-files.service';
// import { AppAnalysisService } from './services/app-analysis.service';

@Component({
  selector: 'lib-igismaplib-upload-file',
  template: `
    <p>
      igismaplib-upload-file works!
    </p>
  `,
  styles: []
})
// <lib-upload-file-lib [authenticationService]="authenticationService" ></lib-upload-file-lib>
export class IgismaplibUploadFileComponent implements OnInit {

  @Input() authenticationService:any
  @Input() PublicURL2:any
  constructor( 
    private uploadFilesService:UploadFilesService,
    private appAnalysisService :AppAnalysisService
      ) {


   }

  ngOnInit() {

    // this.uploadFilesService.authenticationService = this.authenticationService
    // this.uploadFilesService.PublicURL = this.PublicURL2
    // this.appAnalysisService.PublicURL = this.PublicURL2

  }

}
